export function authDirective(authStore) {
  /**
   * 权限指令,用法:
   * - v-auth="'a/b/c'",拥有指定权限
   * - v-auth="['a/b','c/d']",拥有任意权限
   * - v-auth.all="['a/b','c/d']",拥有所有权限
   * - v-auth.page="'a/b'",拥有页面权限(一个页面权限可能由一个或多个后端权限组成,拥有任意一个则视为拥有)
   */
  const authDirective = {
    mounted(el, binding) {
      checkAuthAndHandle(el, binding)
    },
    updated(el, binding) {
      checkAuthAndHandle(el, binding)
    }
  }

  /**
   * 检查权限并处理元素显示
   * @param {HTMLElement} el 元素
   * @param {Object} binding 绑定对象
   */
  const checkAuthAndHandle = (el, binding) => {
    const { value, modifiers } = binding

    if (!value) {
      console.warn('v-permission 指令需要传入权限资源路径')
      return
    }

    let hasAuth = false

    if (modifiers.page) {
      hasAuth = authStore.hasPage(value)
    } else if (typeof value === 'string') {
      // 单个权限
      hasAuth = authStore.has(value)
    } else if (Array.isArray(value)) {
      // 多个权限
      if (modifiers.all) {
        // 必须全部满足
        hasAuth = authStore.hasAll(value)
      } else {
        // 任意一个满足即可（默认）
        hasAuth = authStore.hasAny(value)
      }
    }

    if (!hasAuth) {
      // 没有权限，移除元素
      el.parentNode?.removeChild(el)
    }
  }

  return authDirective
}

export default { authDirective }
